export type MediaType = "电影" | "电视剧" | "综艺";

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  genre: string;
  region: string;
  year: number;
  rating: number;
  duration: string;
  episodes: number;
  actors: string[];
  director: string;
  updateDate: string;
  tags: string[];
  synopsis: string;
  poster: string;
  hot: number;
}

export const mediaList: MediaItem[] = [
  {
    id: "m001",
    title: "星河彼岸",
    type: "电影",
    genre: "科幻",
    region: "中国",
    year: 2025,
    rating: 8.7,
    duration: "138分钟",
    episodes: 1,
    actors: ["林远航", "苏晚星", "陈默"],
    director: "顾长风",
    updateDate: "2025-09-18",
    tags: ["科幻", "太空", "人文"],
    synopsis:
      "在不远的未来，人类首次向银河系边缘发射载人探索飞船「彼岸号」。年轻的领航员林远航在一次虫洞跃迁中与母星失联，被迫在一片未知星域漂泊。他在废弃的空间站里发现了一段来自地球的旧影像，影像中一位母亲正对着镜头讲述家常，而这段影像的拍摄时间，竟是在他出发之后。为破解谜题，林远航与冷冻舱中苏醒的生物学家苏晚星结伴前行，在浩瀚星河中寻找回家的航道，也重新理解了「距离」与「牵挂」的真正含义。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20silhouette%20before%20a%20vast%20glowing%20nebula%20and%20distant%20spacecraft%2C%20deep%20orange%20and%20teal%20color%20grading%2C%20soft%20volumetric%20light%2C%20dramatic%20minimalist%20composition%2C%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-sci-01&orientation=portrait",
    hot: 98,
  },
  {
    id: "m002",
    title: "长安旧梦",
    type: "电影",
    genre: "古装",
    region: "中国",
    year: 2025,
    rating: 8.4,
    duration: "145分钟",
    episodes: 1,
    actors: ["陆知白", "沈轻烟", "裴铭"],
    director: "谢云舟",
    updateDate: "2025-09-12",
    tags: ["古装", "历史", "权谋"],
    synopsis:
      "盛唐末年，长安城内暗流涌动。落魄书生陆知白因一篇诗文被卷入朝堂党争，被迫与执掌密探机构的女子沈轻烟联手调查一桩悬案。随着线索层层展开，他们发现案件背后牵涉的竟是一场动摇国本的阴谋。在繁华与危机交织的长安城里，两人于灯火阑珊处许下承诺，却也不得不面对家国与私情的抉择。影片以细腻的镜头语言再现了盛唐的市井烟火与宫廷冷月，讲述了一段被历史尘封的旧梦。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20movie%20poster%2C%20elegant%20hanfu%20figure%20under%20lantern%20light%20in%20ancient%20Chang&width=400&height=600&seq=movie-poster-hist-02&orientation=portrait'an%20city%20at%20dusk%2C%20warm%20golden%20amber%20tones%2C%20silk%20texture%2C%20moody%20cinematic%20key%20art%20with%20fine%20grain",
    hot: 95,
  },
  {
    id: "m003",
    title: "霓虹之下",
    type: "电影",
    genre: "犯罪",
    region: "中国香港",
    year: 2024,
    rating: 8.1,
    duration: "126分钟",
    episodes: 1,
    actors: ["高见川", "叶雪莹", "麦子豪"],
    director: "梁志成",
    updateDate: "2025-08-30",
    tags: ["犯罪", "悬疑", "警匪"],
    synopsis:
      "深夜的港口城市，霓虹灯在雨中晕开一片迷离的色彩。缉毒警察高见川在一次行动中失去搭档，从此对这座城市的地下世界抱有近乎偏执的执念。当他追踪一条神秘的走私线路时，遇到了身世复杂的酒吧歌手叶雪莹。两人在真真假假的试探中逐渐靠近真相，也一步步逼近危险的核心。影片以冷峻的影像风格刻画了城市边缘人的挣扎，探讨了正义与代价之间那道模糊的界线。",
    poster:
      "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20thriller%20movie%20poster%2C%20rainy%20neon-lit%20harbor%20street%20at%20night%2C%20lonely%20detective%20back%20view%20with%20umbrella%2C%20deep%20orange%20and%20slate%20blue%20reflections%2C%20cinematic%20contrast%2C%20premium%20key%20art&width=400&height=600&seq=movie-poster-crime-03&orientation=portrait",
    hot: 88,
  },
  {
    id: "m004",
    title: "夏日回声",
    type: "电影",
    genre: "爱情",
    region: "中国",
    year: 2025,
    rating: 7.9,
    duration: "112分钟",
    episodes: 1,
    actors: ["周予安", "许知夏", "温朗"],
    director: "程一鸣",
    updateDate: "2025-09-22",
    tags: ["爱情", "青春", "文艺"],
    synopsis:
      "高考结束的那个夏天，小镇少年周予安在旧唱片店里遇见了来此避暑的城市女孩许知夏。一段看似普通的相遇，因为一盘没有标签的磁带而变得不同。他们沿着磁带里的歌声寻找原唱者，也在寻访的过程中慢慢走进彼此的内心。夏天终会结束，而那段被风与海浪反复吟唱的回声，成为两人青春里最明亮的注脚。影片以清新细腻的笔触，讲述了一段关于成长与告别的夏日恋曲。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20romance%20movie%20poster%2C%20two%20young%20figures%20walking%20by%20a%20sunlit%20seaside%20town%20in%20summer%2C%20soft%20peach%20and%20cream%20tones%2C%20dreamy%20bokeh%2C%20film%20grain%20aesthetic%20key%20art&width=400&height=600&seq=movie-poster-romance-04&orientation=portrait",
    hot: 82,
  },
  {
    id: "m005",
    title: "深海迷航",
    type: "电影",
    genre: "冒险",
    region: "美国",
    year: 2025,
    rating: 8.2,
    duration: "134分钟",
    episodes: 1,
    actors: ["奥文·布莱克", "莉娜·福斯特", "马库斯·里德"],
    director: "戴维·安德森",
    updateDate: "2025-09-05",
    tags: ["冒险", "灾难", "深海"],
    synopsis:
      "一支深海探测队在太平洋底发现了一座从未被记录的巨型海沟，随行的生物学家在其深处捕捉到一种未知的生命信号。当潜艇的通讯系统突然中断，队员们意识到自己并非这片黑暗海域里唯一的访客。氧气在流逝，信任在瓦解，每一次下潜都可能是有去无回。队长奥文必须带领剩余队员在失重与幽暗之间找到生路，而海沟深处那团缓慢移动的微光，正悄悄改变着他们对生命的全部认知。",
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20adventure%20movie%20poster%2C%20sleek%20submersible%20descending%20into%20a%20dark%20ocean%20trench%20with%20glowing%20blue-green%20creature%20light%2C%20teal%20and%20amber%20contrast%2C%20suspenseful%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-deepsea-05&orientation=portrait",
    hot: 90,
  },
  {
    id: "m006",
    title: "山城往事",
    type: "电影",
    genre: "剧情",
    region: "中国",
    year: 2024,
    rating: 8.6,
    duration: "128分钟",
    episodes: 1,
    actors: ["何长明", "孟秋", "孙立群"],
    director: "赵启山",
    updateDate: "2025-07-18",
    tags: ["剧情", "家庭", "现实主义"],
    synopsis:
      "在长江边一座依山而建的老城里，退休工人何长明守着开了三十年的小面馆，等待着远在异乡的儿女回家过年。随着城市改造的推进，老街即将拆迁，面馆也面临关门的命运。何长明固执地守着最后一碗面的味道，试图用熟悉的味道挽留渐渐远去的亲情与岁月。影片以平实的镜头记录下普通人的日常，在一个又一个清晨的烟火气里，讲述了一个关于坚守、记忆与和解的动人故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Realistic%20family%20drama%20movie%20poster%2C%20elderly%20man%20in%20a%20small%20mountain%20city%20noodle%20shop%20at%20dawn%2C%20warm%20muted%20orange%20and%20brown%20tones%2C%20documentary%20style%20key%20art%2C%20gentle%20natural%20light&width=400&height=600&seq=movie-poster-drama-06&orientation=portrait",
    hot: 76,
  },
  {
    id: "m007",
    title: "幻界之门",
    type: "电影",
    genre: "奇幻",
    region: "英国",
    year: 2025,
    rating: 8.3,
    duration: "141分钟",
    episodes: 1,
    actors: ["艾拉·格林", "托马斯·怀特", "索菲亚·奈特"],
    director: "詹姆斯·霍洛威",
    updateDate: "2025-09-28",
    tags: ["奇幻", "冒险", "史诗"],
    synopsis:
      "内向的少女艾拉在老宅的阁楼里发现了一本会自行书写的日记，日记指引她找到了一扇只在月圆之夜才会出现的木门。门后是一片由记忆构成的奇幻世界，破碎的王国等待着一位「记得所有故事」的人来修补。艾拉在这里遇见了失去名字的骑士与守护藏书塔的猫头鹰学者，也逐渐发现自己与这个世界的联系远比想象中更深。当现实的边界开始模糊，她必须做出选择——是留下守护幻界，还是带着勇气回到属于自己的生活。",
    poster:
      "https://readdy.ai/api/search-image?query=Enchanting%20fantasy%20movie%20poster%2C%20young%20girl%20before%20a%20glowing%20ancient%20wooden%20door%20in%20a%20magical%20forest%2C%20warm%20amber%20and%20violet%20glow%2C%20whimsical%20storybook%20key%20art%2C%20soft%20dappled%20light&width=400&height=600&seq=movie-poster-fantasy-07&orientation=portrait",
    hot: 86,
  },
  {
    id: "m008",
    title: "追风少年",
    type: "电影",
    genre: "运动",
    region: "中国",
    year: 2025,
    rating: 7.8,
    duration: "118分钟",
    episodes: 1,
    actors: ["方野", "徐子恒", "郑小雨"],
    director: "邓凯",
    updateDate: "2025-09-15",
    tags: ["运动", "励志", "青春"],
    synopsis:
      "在小城长大的少年方野有着惊人的骑行天赋，却因家境原因只能在修车铺里帮工。一次偶然的机会，他被退役教练徐子恒看中，加入了濒临解散的少年自行车队。为了争取参加全国青年赛的资格，一群被看轻的少年在清晨与黄昏的公路上挥汗如雨。比赛日期临近，队内却爆出伤病与分歧。面对质疑与压力，方野和队友们决定用速度证明自己——不是为了名次，而是为了那个曾被所有人嘲笑过的梦想。",
    poster:
      "https://readdy.ai/api/search-image?query=Inspiring%20sports%20movie%20poster%2C%20young%20cyclist%20racing%20down%20a%20golden%20country%20road%20at%20sunset%2C%20dynamic%20motion%20blur%2C%20warm%20orange%20sky%2C%20energetic%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-sports-08&orientation=portrait",
    hot: 79,
  },
  {
    id: "m009",
    title: "迷雾之城",
    type: "电视剧",
    genre: "悬疑",
    region: "中国",
    year: 2025,
    rating: 8.8,
    duration: "45分钟/集",
    episodes: 32,
    actors: ["江叙", "温言", "罗晟"],
    director: "鹿鸣",
    updateDate: "2025-09-30",
    tags: ["悬疑", "推理", "都市"],
    synopsis:
      "临江市连续出现多起看似毫无关联的失踪案，刑警队新人江叙在整理旧档案时，发现这些案件都与十五年前的一桩悬案有着隐秘的联系。随着调查深入，一张笼罩整座城市的大网逐渐浮现。江叙与法医温言、记者罗晟组成临时搭档，在层层迷雾中寻找真相。每一个被揭开秘密的人都会付出代价，而真相的重量，远比他们想象中更加沉重。剧集以紧凑的节奏与缜密的推理，勾勒出一座在谎言中沉浮的城市。",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20TV%20series%20poster%2C%20foggy%20modern%20city%20skyline%20at%20night%20with%20a%20lone%20silhouette%20detective%2C%20cold%20blue-gray%20and%20warm%20orange%20streetlight%20contrast%2C%20cinematic%20key%20art&width=400&height=600&seq=drama-poster-mystery-09&orientation=portrait",
    hot: 99,
  },
  {
    id: "m010",
    title: "医者仁心",
    type: "电视剧",
    genre: "都市",
    region: "中国",
    year: 2025,
    rating: 8.3,
    duration: "42分钟/集",
    episodes: 40,
    actors: ["沈知远", "林素心", "白宇宁"],
    director: "许文康",
    updateDate: "2025-09-25",
    tags: ["都市", "职场", "医疗"],
    synopsis:
      "年轻的外科医生沈知远从大医院调任至一家社区医院，初来乍到的他并不适应这里琐碎而真实的日常。在资深医生林素心的带领下，他逐渐明白，治病救人不仅仅依靠精湛的技术，更需要耐心与共情。从急诊室的生死时速到病房里的人情冷暖，每一集都是一个关于生命与选择的故事。当一场突发公共卫生事件来临，全院上下携手应对，医者们用行动诠释了「仁心」二字的分量。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20medical%20drama%20TV%20poster%2C%20young%20doctor%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%2C%20clean%20white%20and%20soft%20orange%20accents%2C%20professional%20cinematic%20key%20art&width=400&height=600&seq=drama-poster-medical-10&orientation=portrait",
    hot: 84,
  },
  {
    id: "m011",
    title: "大宋风云",
    type: "电视剧",
    genre: "历史",
    region: "中国",
    year: 2024,
    rating: 8.5,
    duration: "46分钟/集",
    episodes: 45,
    actors: ["萧景珩", "云清晏", "贺兰澈"],
    director: "裴仲文",
    updateDate: "2025-06-20",
    tags: ["历史", "古装", "权谋"],
    synopsis:
      "北宋年间，年轻的枢密院编修萧景珩因直言进谏而卷入朝堂纷争。彼时边疆战事吃紧，朝廷内部新旧两派明争暗斗。萧景珩与镇守边关的女将军云清晏因一封军报结缘，二人一文一武，在风雨飘摇的时代里艰难维系着心中的道义。剧集以宏大的历史背景为舞台，通过一个个鲜活的人物命运，展现了那个时代的风骨与苍凉，也探讨了何为真正的家国天下。",
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20Chinese%20historical%20drama%20poster%2C%20armored%20general%20and%20scholar%20silhouettes%20before%20an%20ancient%20city%20gate%20at%20sunset%2C%20deep%20amber%20and%20bronze%20tones%2C%20epic%20cinematic%20key%20art&width=400&height=600&seq=drama-poster-history-11&orientation=portrait",
    hot: 81,
  },
  {
    id: "m012",
    title: "青春纪事",
    type: "电视剧",
    genre: "校园",
    region: "中国",
    year: 2025,
    rating: 7.9,
    duration: "40分钟/集",
    episodes: 24,
    actors: ["夏予川", "黎南音", "顾时予"],
    director: "温子昂",
    updateDate: "2025-09-10",
    tags: ["校园", "青春", "友情"],
    synopsis:
      "高二分班后，五个性格迥异的少年被分到了同一个班级。学霸夏予川、文艺少女黎南音、运动健将顾时予，以及另外两位吵吵闹闹的同桌，共同度过了充实而兵荒马乱的一年。从运动会到文艺汇演，从月考排名到深夜的悄悄话，青春的烦恼与闪光被一一记录。这段看似平凡的校园时光，多年后回望，却成了每个人心底最柔软的记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20youth%20campus%20drama%20poster%2C%20group%20of%20high%20school%20students%20laughing%20under%20warm%20afternoon%20sunlight%20in%20a%20classroom%2C%20fresh%20pastel%20and%20warm%20orange%20tones%2C%20cheerful%20key%20art&width=400&height=600&seq=drama-poster-campus-12&orientation=portrait",
    hot: 73,
  },
  {
    id: "m013",
    title: "暗夜追踪",
    type: "电视剧",
    genre: "刑侦",
    region: "中国",
    year: 2025,
    rating: 8.6,
    duration: "44分钟/集",
    episodes: 28,
    actors: ["秦岭", "苏未晞", "程野"],
    director: "陆铭川",
    updateDate: "2025-09-28",
    tags: ["刑侦", "悬疑", "动作"],
    synopsis:
      "资深刑警秦岭接手了一桩手法极其隐蔽的连环案，所有线索都指向一个早已销声匿迹的名字。为了追查真相，他与擅长数据分析的技术警苏未晞组成专案小组，在城市的暗夜里展开一场与时间赛跑的追踪。嫌疑人的反侦察能力远超常人，每一条线索似乎都在引导他们走向陷阱。随着调查深入，秦岭发现自己面对的不仅是狡猾的对手，还有体制与人性的重重考验。",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20investigation%20TV%20poster%2C%20detective%20examining%20evidence%20board%20in%20a%20dark%20office%2C%20rain-streaked%20window%2C%20moody%20orange%20and%20charcoal%20tones%2C%20tense%20cinematic%20key%20art&width=400&height=600&seq=drama-poster-detective-13&orientation=portrait",
    hot: 92,
  },
  {
    id: "m014",
    title: "星辰大海",
    type: "电视剧",
    genre: "科幻",
    region: "中国",
    year: 2025,
    rating: 8.1,
    duration: "48分钟/集",
    episodes: 36,
    actors: ["季凉川", "何以宁", "莫北"],
    director: "宋行舟",
    updateDate: "2025-09-20",
    tags: ["科幻", "未来", "剧情"],
    synopsis:
      "公元2147年，人类已在月球与火星建立起规模庞大的殖民地。年轻的空间站工程师季凉川被派往深空补给基地执行一项绝密任务，却在那里遇到了失踪多年的科学家何以宁。两人联手破解一段被加密的远古信号，逐渐揭开人类星际扩张背后被隐藏的真相。宏大的宇宙图景与细腻的人物情感交织，讲述了一个关于探索、牺牲与希望的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20space%20TV%20series%20poster%2C%20orbital%20space%20station%20above%20a%20blue%20planet%20with%20warm%20sunrise%20limb%2C%20lone%20engineer%20silhouette%2C%20deep%20teal%20and%20amber%20grading%2C%20epic%20key%20art&width=400&height=600&seq=drama-poster-scifi-14&orientation=portrait",
    hot: 80,
  },
  {
    id: "m015",
    title: "岁月长歌",
    type: "电视剧",
    genre: "年代",
    region: "中国",
    year: 2024,
    rating: 8.7,
    duration: "45分钟/集",
    episodes: 42,
    actors: ["陈砚秋", "柳如诗", "韩铮"],
    director: "周慕云",
    updateDate: "2025-05-30",
    tags: ["年代", "情感", "群像"],
    synopsis:
      "故事从上世纪八十年代的纺织厂大院讲起，围绕陈家三兄妹的成长与命运展开。大哥陈砚秋继承了父亲的手艺，在时代浪潮中坚守着老厂的荣光；二妹柳如诗南下闯荡，成为第一批抓住机遇的创业者；三弟韩铮则在理想与现实之间不断碰撞。四十年光阴流转，大院里的人们各自走向不同的人生，而那份跨越岁月的温情与羁绊，始终如一首悠长的歌，在时光中回响。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20TV%20poster%2C%20family%20in%201980s%20textile%20factory%20courtyard%20with%20bicycles%20and%20warm%20evening%20light%2C%20sepia%20and%20faded%20orange%20tones%2C%20nostalgic%20cinematic%20key%20art&width=400&height=600&seq=drama-poster-period-15&orientation=portrait",
    hot: 78,
  },
  {
    id: "m016",
    title: "笑看风云",
    type: "综艺",
    genre: "真人秀",
    region: "中国",
    year: 2025,
    rating: 8.4,
    duration: "90分钟/期",
    episodes: 12,
    actors: ["主持人·大鹏", "常驻嘉宾·阿雅", "常驻嘉宾·小亮"],
    director: "综艺制作中心",
    updateDate: "2025-09-29",
    tags: ["真人秀", "搞笑", "户外"],
    synopsis:
      "《笑看风云》是一档以「人生选择题」为核心的户外真人秀。每期节目中，嘉宾们会收到一个源于真实生活的选择情境，并需要通过完成任务来体验不同选择带来的结果。节目组走遍大江南北，把镜头对准普通人的喜怒哀乐，在爆笑之余也带来温暖的思考。这一季，嘉宾们将挑战更出人意料的关卡，在欢笑与感动中陪观众一起「笑看风云」。",
    poster:
      "https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20reality%20show%20poster%2C%20colorful%20playful%20stage%20with%20confetti%20and%20friendly%20hosts%20silhouettes%2C%20energetic%20orange%20and%20cream%20palette%2C%20fun%20graphic%20key%20art&width=400&height=600&seq=variety-poster-reality-16&orientation=portrait",
    hot: 89,
  },
  {
    id: "m017",
    title: "美食奇遇记",
    type: "综艺",
    genre: "美食",
    region: "中国",
    year: 2025,
    rating: 8.9,
    duration: "75分钟/期",
    episodes: 10,
    actors: ["主厨·老周", "美食家·苏眉", "主持人·林小满"],
    director: "纪录片工作室",
    updateDate: "2025-09-26",
    tags: ["美食", "纪录", "人文"],
    synopsis:
      "三位对食物怀抱热爱的探索者，带着一张没有目的地的地图出发，去寻找藏在街头巷尾与田间地头的味道。从清晨的早市到深夜的排档，从传承三代的老师傅到返乡创业的年轻人，每一道菜背后都有一段关于生活与坚守的故事。节目以精致的镜头记录下食物的色香味，也记录下人与土地之间最质朴的连接。这是一场关于美食的奇遇，更是一次关于生活的回归。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20food%20documentary%20show%20poster%2C%20overhead%20view%20of%20steaming%20handmade%20dishes%20on%20a%20rustic%20wooden%20table%20with%20warm%20lantern%20light%2C%20rich%20orange%20and%20earthy%20tones%2C%20appetizing%20key%20art&width=400&height=600&seq=variety-poster-food-17&orientation=portrait",
    hot: 87,
  },
  {
    id: "m018",
    title: "音乐无限",
    type: "综艺",
    genre: "音乐",
    region: "中国",
    year: 2025,
    rating: 8.2,
    duration: "100分钟/期",
    episodes: 12,
    actors: ["导师·陈以恒", "导师·许晚", "导师·高远"],
    director: "音乐制作组",
    updateDate: "2025-09-24",
    tags: ["音乐", "竞演", "舞台"],
    synopsis:
      "《音乐无限》是一档面向新生代唱作人的竞演舞台。来自不同背景的年轻音乐人在这里重新编曲、合作演出，用音乐讲述属于这个时代的故事。三位风格迥异的导师将从创作、演唱与舞台表现等维度给予指导，帮助选手突破自我。每一期都诞生令人惊艳的舞台，而真正打动观众的，是音乐背后那份真诚与热爱。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylish%20music%20competition%20show%20poster%2C%20singer%20silhouette%20on%20a%20dramatic%20stage%20with%20warm%20spotlights%20and%20sound%20waves%2C%20deep%20orange%20and%20gold%20tonight%20palette%2C%20energetic%20key%20art&width=400&height=600&seq=variety-poster-music-18&orientation=portrait",
    hot: 83,
  },
  {
    id: "m019",
    title: "欢乐大本营",
    type: "综艺",
    genre: "喜剧",
    region: "中国",
    year: 2025,
    rating: 7.9,
    duration: "70分钟/期",
    episodes: 16,
    actors: ["团长·老王", "团员·豆豆", "团员·阿哲"],
    director: "喜剧工坊",
    updateDate: "2025-09-22",
    tags: ["喜剧", "亲子", "合家欢"],
    synopsis:
      "欢迎来到《欢乐大本营》，这里是属于全家人一起开怀大笑的地方。节目以轻松幽默的短剧、妙趣横生的互动游戏和即兴喜剧为主要内容，每一期都围绕一个贴近生活的主题展开。无论是亲子之间的温馨日常，还是邻里之间的小小误会，都在笑声中被温柔化解。放下一天的疲惫，和家人一起享受这段纯粹的欢乐时光吧。",
    poster:
      "https://readdy.ai/api/search-image?query=Cheerful%20family%20comedy%20show%20poster%2C%20playful%20cartoon-style%20stage%20with%20smiling%20hosts%20and%20colorful%20props%2C%20bright%20orange%20and%20cream%20palette%2C%20joyful%20key%20art&width=400&height=600&seq=variety-poster-comedy-19&orientation=portrait",
    hot: 68,
  },
  {
    id: "m020",
    title: "探险家联盟",
    type: "综艺",
    genre: "户外",
    region: "中国",
    year: 2025,
    rating: 8.5,
    duration: "85分钟/期",
    episodes: 10,
    actors: ["队长·岩松", "队员·小汐", "队员·泽宇"],
    director: "户外探索组",
    updateDate: "2025-09-18",
    tags: ["户外", "冒险", "纪实"],
    synopsis:
      "五位热爱自然的探险者组成联盟，前往那些鲜有人至的秘境，完成一项项充满挑战的探索任务。从高原冰川到热带雨林，从沙漠腹地到无人海岛，节目以纪实的手法呈现大自然的壮美与严酷。队员们在极限环境中学习协作与生存，也在一次次突破中重新认识自己。这不仅是一场身体的远行，更是一次心灵的探索。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20outdoor%20documentary%20show%20poster%2C%20hikers%20crossing%20a%20mountain%20ridge%20at%20golden%20sunrise%20with%20backpacks%2C%20warm%20orange%20sky%20and%20dark%20ridges%2C%20epic%20key%20art&width=400&height=600&seq=variety-poster-outdoor-20&orientation=portrait",
    hot: 85,
  },
  {
    id: "m021",
    title: "时光信笺",
    type: "电影",
    genre: "爱情",
    region: "韩国",
    year: 2025,
    rating: 8.0,
    duration: "116分钟",
    episodes: 1,
    actors: ["韩诗允", "朴志勋", "李恩彩"],
    director: "金泰宇",
    updateDate: "2025-09-08",
    tags: ["爱情", "奇幻", "治愈"],
    synopsis:
      "图书管理员韩诗允有一个特殊的习惯——她会把读到的好句子抄写下来，寄给一个陌生地址。多年后，一位名叫朴志勋的钢琴家循着这些信找到了她。原来，那些信件的收件人早已搬离，而志勋正是那间公寓的新住户。两人因一叠迟到的信笺相识，在旧书店与音乐厅之间慢慢走近。当诗允终于鼓起勇气写下属于自己的一封情书，时间仿佛也为这份迟来的心意温柔停留。",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20Korean%20romance%20movie%20poster%2C%20young%20woman%20reading%20letters%20in%20a%20cozy%20old%20bookstore%20with%20warm%20afternoon%20light%2C%20soft%20peach%20and%20amber%20tones%2C%20tender%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-kromance-21&orientation=portrait",
    hot: 77,
  },
  {
    id: "m022",
    title: "无声证词",
    type: "电影",
    genre: "悬疑",
    region: "中国",
    year: 2025,
    rating: 8.4,
    duration: "124分钟",
    episodes: 1,
    actors: ["顾清晏", "白静姝", "程守正"],
    director: "罗维安",
    updateDate: "2025-09-19",
    tags: ["悬疑", "法庭", "剧情"],
    synopsis:
      "一桩证据链完整的凶杀案即将宣判，年轻检察官顾清晏却在庭审前的最后时刻发现了一处被所有人忽略的细节。为了查明真相，他顶着巨大压力重新梳理案件，并与始终坚称无罪的被告辩护律师白静姝产生交集。两人在对抗与角力中逐渐发现，真正的证词或许一直没有说出口。法庭之上的唇枪舌剑，与法庭之外的暗流涌动交织，共同指向一个被刻意掩埋的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20courtroom%20thriller%20movie%20poster%2C%20empty%20courtroom%20with%20a%20single%20beam%20of%20light%2C%20lone%20prosecutor%20silhouette%2C%20moody%20amber%20and%20charcoal%20contrast%2C%20dramatic%20key%20art&width=400&height=600&seq=movie-poster-court-22&orientation=portrait",
    hot: 88,
  },
  {
    id: "m023",
    title: "龙腾九霄",
    type: "电视剧",
    genre: "武侠",
    region: "中国",
    year: 2025,
    rating: 8.3,
    duration: "44分钟/集",
    episodes: 38,
    actors: ["萧逸尘", "苏挽月", "独孤鸣"],
    director: "华山",
    updateDate: "2025-09-27",
    tags: ["武侠", "古装", "江湖"],
    synopsis:
      "江湖传言，失传百年的「九霄剑谱」重现人间，一时间各派蠢蠢欲动。自幼在深山习剑的少年萧逸尘奉师命下山，只为查明师门旧案。旅途中，他结识了机敏洒脱的侠女苏挽月与亦正亦邪的剑客独孤鸣。三人立场各异，却因共同的线索而结伴同行。剑影江湖，恩怨情仇，少年在一次次抉择中逐渐明白，真正的「九霄」，不在剑谱，而在心中。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20wuxia%20TV%20poster%2C%20swordsman%20silhouette%20on%20a%20misty%20mountain%20peak%20with%20flowing%20robe%2C%20warm%20amber%20and%20ink-blue%20tones%2C%20dynamic%20martial%20arts%20key%20art&width=400&height=600&seq=drama-poster-wuxia-23&orientation=portrait",
    hot: 82,
  },
  {
    id: "m024",
    title: "城市之光",
    type: "电影",
    genre: "剧情",
    region: "中国",
    year: 2024,
    rating: 8.5,
    duration: "130分钟",
    episodes: 1,
    actors: ["陆沉", "黎晚晴", "周野"],
    director: "方致远",
    updateDate: "2025-06-12",
    tags: ["剧情", "都市", "群像"],
    synopsis:
      "深夜的外卖骑手、值夜班的便利店店员、坚持开夜班出租的司机、加班到凌晨的设计师……在这座从不真正入睡的城市里，无数普通人在自己的轨道上默默前行。一次偶然的停电，让几个原本毫无交集的人短暂地聚在了一起。在黑暗中，他们分享着各自的故事，也点亮了彼此的生活。影片用温柔而克制的镜头，捕捉城市缝隙中那些微小却坚定的光。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20ensemble%20drama%20movie%20poster%2C%20city%20street%20at%20night%20with%20glowing%20windows%20and%20a%20lone%20delivery%20rider%2C%20cozy%20orange%20streetlight%20against%20cool%20blue%20night%2C%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-city-24&orientation=portrait",
    hot: 75,
  },
];

export const genreOptions = ["全部", "动作", "爱情", "喜剧", "科幻", "悬疑", "古装", "剧情", "冒险", "犯罪", "历史", "都市", "校园", "刑侦", "武侠", "奇幻", "运动", "真人秀", "美食", "音乐", "户外", "年代", "家庭", "职场", "医疗"];
export const regionOptions = ["全部", "中国", "中国香港", "美国", "英国", "韩国"];
export const yearOptions = ["全部", "2025", "2024", "2023"];